module.exports = __webpack_public_path__ + "static/media/ZvukCHYBA.db85943d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/sounds/ZvukCHYBA.mp3
// module id = 807
// module chunks = 0